import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';
import App from './App';

// Block direct access - require proxy
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.') || hostname.startsWith('10.') || hostname.startsWith('172.');
  const isProxyAccess = hostname.includes('dev-v1.fawesome-hypercasual.workers.dev');
  const isDirectAccess = hostname.includes('pages.dev');
  
  // Block direct Pages access, allow proxy and localhost
  if (isDirectAccess && !isLocalhost && !isProxyAccess) {
    // Redirect to proxy URL
    const proxyUrl = 'https://dev-v1.fawesome-hypercasual.workers.dev/admin';
    const currentPath = window.location.pathname.replace(/^\/admin/, '') || '/';
    window.location.replace(proxyUrl + currentPath + window.location.search + window.location.hash);
    // Show blocking message while redirecting
    document.body.innerHTML = '<div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: sans-serif;"><div style="text-align: center;"><h1>Redirecting...</h1><p>Please access this app via the proxy URL.</p></div></div>';
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

